/**
* @feat <>
import { fetchAdvByTypes } from "@/apis/home";
*/
import { request } from "@/request/request";

// 拉取home数据
export function fetchHomeData(
    params,
    axiosRequestConfig,
) {
    return request(
        {
            method: "GET",
            url: "/Api/Home/Index",
            ...(axiosRequestConfig || false),
        },
        params
    );
}
// 根据类型拉取广告图
export function fetchAdvByTypes(
    params,
    axiosRequestConfig,
) {
    return request(
        {
            method: "GET",
            url: "/Api/Home/GetAdvByTypes",
            ...(axiosRequestConfig || false),
        },
        params
    );
}
